import { render } from "./Presentismo.vue?vue&type=template&id=199846fe&scoped=true"
import script from "./Presentismo.vue?vue&type=script&lang=js"
export * from "./Presentismo.vue?vue&type=script&lang=js"

import "./Presentismo.vue?vue&type=style&index=0&id=199846fe&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199846fe"]])

export default __exports__